class MobileSlider {
  constructor() {
    this.subHeader = document.querySelector('.header-sub-tablet-down');
    this.description = document.querySelector('.gsct-description__mobile p');
    this.slides = document.querySelectorAll('[id^="gsctDescriptionPage-mobile"]');
    this.currentSlide = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.autoplayInterval = 5000;
    this.autoplayTimer = null;
    this.isHovering = false;

    if (window.innerWidth <= 749 && !document.body.classList.contains('overlay-active')) {
      this.init();
    }

    this.setupOverlayObserver();

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 749 && !this.initialized && !document.body.classList.contains('overlay-active')) {
        this.init();
      } else if ((window.innerWidth > 749 || document.body.classList.contains('overlay-active')) && this.initialized) {
        this.destroy();
      }
    });
  }

  setupOverlayObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains('overlay-active')) {
          if (this.initialized) {
            this.destroy();
          }
        } else if (window.innerWidth <= 749) {
          if (!this.initialized) {
            this.init();
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  init() {
    this.initialized = true;
    this.createNavigation();
    this.bindEvents();
    this.goToSlide(0);

    if (!this.isHovering) {
      this.startAutoplay();
    }

    this.subHeader.addEventListener('mouseenter', () => {
      this.isHovering = true;
      this.stopAutoplay();
    });

    this.subHeader.addEventListener('mouseleave', () => {
      this.isHovering = false;
      if (this.initialized && !document.body.classList.contains('overlay-active')) {
        this.startAutoplay();
      }
    });
  }

  destroy() {
    this.initialized = false;
    this.isHovering = false;
    if (this.navigation) {
      this.navigation.remove();
    }
    this.description.style.transform = '';
    this.removeEvents();
    this.stopAutoplay();

    this.subHeader.removeEventListener('mouseenter', () => {});
    this.subHeader.removeEventListener('mouseleave', () => {});
  }

  createNavigation() {
    this.navigation = document.createElement('div');
    this.navigation.className = 'slider-nav';

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'slider-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.resetAutoplay();
      });
      this.navigation.appendChild(dot);
    });

    this.subHeader.appendChild(this.navigation);
    this.dots = this.navigation.querySelectorAll('.slider-dot');
  }

  startAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
    }

    this.autoplayTimer = setInterval(() => {
      if (!this.isHovering && !document.body.classList.contains('overlay-active')) {
        const nextSlide = (this.currentSlide + 1) % this.slides.length;
        this.goToSlide(nextSlide);
      }
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  bindEvents() {
    this.description.addEventListener('touchstart', this.touchStart.bind(this));
    this.description.addEventListener('touchend', this.touchEnd.bind(this));
    this.description.addEventListener('touchmove', this.touchMove.bind(this));
  }

  removeEvents() {
    this.description.removeEventListener('touchstart', this.touchStart.bind(this));
    this.description.removeEventListener('touchend', this.touchEnd.bind(this));
    this.description.removeEventListener('touchmove', this.touchMove.bind(this));
  }

  touchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.stopAutoplay();
  }

  touchMove(e) {
    e.preventDefault();
  }

  touchEnd(e) {
    this.touchEndX = e.changedTouches[0].clientX;

    // Calculate swipe distance
    const swipeDistance = this.touchStartX - this.touchEndX;

    // Check if overlay is active
    if (document.body.classList.contains('overlay-active')) {
      hideOverlay(); // Dismiss overlay on any swipe when it's active
      return;
    }

    // Normal slider behavior if no overlay
    if (swipeDistance > 50 && this.currentSlide < this.slides.length - 1) {
      this.goToSlide(this.currentSlide + 1);
    }

    if (swipeDistance < -50 && this.currentSlide > 0) {
      this.goToSlide(this.currentSlide - 1);
    }

    if (!this.isHovering && !document.body.classList.contains('overlay-active')) {
      this.startAutoplay();
    }
  }

  goToSlide(index) {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
    }

    this.currentSlide = index;
    this.description.style.transform = `translateX(-${index * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });

    if (!this.isHovering && !document.body.classList.contains('overlay-active')) {
      this.startAutoplay();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let klaviyoFormId = 'Xi5bBT';
  if (window.gsct_store_settings && window.gsct_store_settings.klaviyoFormId) {
    klaviyoFormId = window.gsct_store_settings.klaviyoFormId;
  }

  // document.getElementById('HeaderMenu-join-waiting-list').addEventListener('click', function (e) {
  //   e.preventDefault();
  //   window._klOnsite = window._klOnsite || [];
  //   window._klOnsite.push(['openForm', klaviyoFormId]);
  // });

  const navItems = document.querySelectorAll('.header-menu .list-menu li');
  navItems.forEach((item) => {
    const dropdown = item.querySelector('.header-dropdown');
    let timeoutId;

    // Show dropdown on mouse enter
    item.addEventListener('mouseenter', () => {
      clearTimeout(timeoutId);
      dropdown.classList.add('is-active');
    });

    // Hide dropdown on mouse leave with delay
    item.addEventListener('mouseleave', () => {
      timeoutId = setTimeout(() => {
        dropdown.classList.remove('is-active');
      }, 50); // 200ms delay
    });
  });

  let comingSoonButton = document.querySelector('.button-coming-soon');
  if (comingSoonButton) {
    comingSoonButton.addEventListener('click', function (e) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      // Check if button has data-klaviyo-id attribute
      if (comingSoonButton.dataset.klaviyoId) {
        window._klOnsite.push(['openForm', comingSoonButton.dataset.klaviyoId]);
      } else {
        window._klOnsite.push(['openForm', klaviyoFormId]);
      }
    });
  }

  const hamburgerButton = document.querySelector('.mobile-hamburger-menu__toggle');
  console.log(hamburgerButton);
  if (hamburgerButton) {
    hamburgerButton.addEventListener('click', (e) => {
      e.preventDefault();

      const hamburgerMenu = document.querySelector('.mobile-hamburger-menu');

      if (hamburgerMenu && hamburgerMenu.classList.contains('open')) {
        hamburgerMenu.classList.remove('open');
        document.body.classList.remove('no-scroll');

      } else if (hamburgerMenu) {
        hamburgerMenu.classList.add('open');
        document.body.classList.add('no-scroll');
      }
    });
  }

  let gridPopupLinks = document.querySelectorAll('.popup-link');
  if (gridPopupLinks.length > 0) {
    gridPopupLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        // Check if link has data-klaviyo-id attribute
        if (this.dataset.klaviyoId) {
          window._klOnsite.push(['openForm', this.dataset.klaviyoId]);
        } else {
          window._klOnsite.push(['openForm', klaviyoFormId]);
        }
      });
    });
  }

  if (document.body.classList.contains('page-type__index')) {
    window.currentMobileSlider = new MobileSlider();
  }

  // Overlay handling
  const desktopBags = document.querySelector('.gsct-description__tablet-up').querySelectorAll('.mini-bag');
  const mobileBags = document.querySelector('.gsct-description__mobile').querySelectorAll('.mini-bag');
  const overlay = document.querySelector('.hover-overlay');
  const centeredImage = document.querySelector('.centered-image');
  const centeredImageTitle = document.querySelector('.centered-image-title');
  const connectorLine = document.querySelector('.connector-line');
  const circleRadius = 14.5;
  const lineOverlap = 1;

  function showOverlay(bag) {
    const rect = bag.getBoundingClientRect();
    const circleCenter = {
      x: Math.round(rect.left + rect.width / 2),
      y: Math.round(rect.top + rect.height / 2),
    };

    const centerContainer = document.querySelector('.centered-image-container');
    const centerRect = centerContainer.getBoundingClientRect();

    const targetPoint = {
      x: Math.round(centerRect.left + centerRect.width / 2),
      y: Math.round(centerRect.top),
    };

    const dx = targetPoint.x - circleCenter.x;
    const dy = targetPoint.y - circleCenter.y;
    const angle = Math.atan2(dy, dx);

    const startPoint = {
      x: circleCenter.x + Math.cos(angle) * (circleRadius - lineOverlap),
      y: circleCenter.y + Math.sin(angle) * (circleRadius - lineOverlap),
    };

    const distance =
      Math.sqrt(Math.pow(targetPoint.x - startPoint.x, 2) + Math.pow(targetPoint.y - startPoint.y, 2)) + lineOverlap;

    connectorLine.style.width = `${Math.round(distance)}px`;
    connectorLine.style.left = `${Math.round(startPoint.x)}px`;
    connectorLine.style.top = `${Math.round(startPoint.y)}px`;
    connectorLine.style.transform = `rotate(${(angle * 180) / Math.PI}deg)`;

    const largeImageUrl = bag.dataset.largeImage;
    const imageTitle = bag.dataset.title;

    if (centeredImage && largeImageUrl) {
      centeredImage.src = largeImageUrl;
    }
    if (centeredImageTitle && imageTitle) {
      centeredImageTitle.textContent = imageTitle;
    }

    overlay.classList.add('active');
    document.body.classList.add('overlay-active');
    document.body.style.overflow = 'hidden';
  }

  function hideOverlay() {
    overlay.classList.remove('active');
    document.body.classList.remove('overlay-active');
    document.body.style.overflow = 'auto';
  }

  desktopBags.forEach((bag) => {
    bag.addEventListener('mouseenter', function () {
      showOverlay(this);
    });
    bag.addEventListener('mouseleave', hideOverlay);
  });

  mobileBags.forEach((bag) => {
    bag.addEventListener('click', function (e) {
      e.preventDefault();
      showOverlay(this);
    });
  });

  const overlayContent = document.querySelector('.overlay-content');
  if (overlayContent) {
    overlayContent.addEventListener('mouseleave', hideOverlay);
  }

  overlay.addEventListener('click', function (e) {
    // If click is on overlay or any element that's not inside .centered-image-container
    if (!e.target.closest('.centered-image-container')) {
      hideOverlay();
    }
  });

  // Add close button handler
  const closeButton = document.querySelector('.modal-close-button');
  if (closeButton) {
    closeButton.addEventListener('click', hideOverlay);
  }
});
